import {forwardRef} from 'react'

import useMediaQuery from '@mui/material/useMediaQuery'

import {useSwipeable} from 'react-swipeable'

import Dialog from '@mui/material/Dialog'
import RSVPInviteForm from './RSVPInviteForm'

import Paper from '@mui/material/Paper'




const SwipeablePaper = forwardRef(function SwipeablePaper({ onClose, ...other }, ref) {
  const handlers = useSwipeable({
    onSwipedDown: ({velocity, deltaY}) => {
      if (velocity > 3 && deltaY > 300) {
        onClose?.()
      }
    },
    delta: 100,
    velocity: 2,
    trackTouch: true,
  })

  return <Paper ref={ref} {...other} {...handlers} />
})




const RSVPInviteDialog = ({ eventID, eventName, open, onClose }) => {
  const isLg = useMediaQuery(theme => theme.breakpoints.down('lg'))

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth
      fullScreen={isLg}
      maxWidth='lg'
      PaperComponent={SwipeablePaper}
      PaperProps={{
        onClose,
        sx: {
          height: isLg ? null : '90vh',
          maxHeight: 'none'
        }
      }}>
      <RSVPInviteForm 
        eventID={eventID} 
        eventName={eventName}
        close={onClose}
      />
    </Dialog>
  )
}



export default RSVPInviteDialog